import { Item } from '@teetsh/app/src/types/programmations';
import { ItemBlock } from './Row';
import { MergedRow } from './Subrow';
import { isElementEmpty } from '../../isElementEmpty';

function serializeItem(item?: Item): string | undefined {
  if (!item) {
    return undefined;
  }
  const { value, color, ficheDePrep, sequence, attachments } = item;

  return JSON.stringify({ value, color, ficheDePrep, sequence, attachments });
}

export function extractMergedRow(
  blocks: ItemBlock[],
  rowIndex: number,
): {
  mergedRow?: MergedRow;
} {
  if (blocks.filter(b => !isElementEmpty(b.items[rowIndex])).length <= 1) {
    // 0 or 1 item in the row, do not merge
    return { mergedRow: undefined };
  }
  const firstNonEmptyColumnIndex = blocks.findIndex(
    block => !isElementEmpty(block.items[rowIndex]),
  );
  const lastNonEmptyColumnIndex = blocks.reduce(
    (lastIdx, block, idx) =>
      !isElementEmpty(block.items[rowIndex]) ? idx : lastIdx,
    -1,
  );

  // items at given index have to be identical for blocks between firstNonEmptyColumn and lastNonEmptyColumn
  const item = blocks[firstNonEmptyColumnIndex].items[rowIndex];
  const allItemsAreIdentical = blocks
    .slice(firstNonEmptyColumnIndex, lastNonEmptyColumnIndex + 1)
    .every(
      block => serializeItem(block.items[rowIndex]) === serializeItem(item),
    );

  if (allItemsAreIdentical) {
    return {
      mergedRow: {
        item,
        leftBlockWidth: firstNonEmptyColumnIndex,
        rightBlockWidth: blocks.length - (lastNonEmptyColumnIndex + 1),
      },
    };
  }

  return { mergedRow: undefined };
}
